import { Component, inject, signal } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthService } from '../../services/AuthService';
import { Button } from 'primeng/button';
import { InputText } from 'primeng/inputtext';
import { LayoutService } from '../../services/LayoutService';
import { RegistryService } from '../../services/RegistryService';
import { ProgressSpinner } from 'primeng/progressspinner';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  imports: [
    ReactiveFormsModule,
    Button,
    InputText,
    ProgressSpinner,
    TranslocoPipe,
  ],
})
export class LoginComponent {
  private auth = inject(AuthService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private registry = inject(RegistryService);
  private fb = inject(FormBuilder);
  private transloco = inject(TranslocoService);
  public layoutService = inject(LayoutService);

  public loginForm = this.fb.group({
    phone: ['', [Validators.required]],
    rememberMe: [false]
  });

  public loading = signal(false);

  constructor() {
    const data = this.route.snapshot.data;
    if (data.hasOwnProperty('logout')) {
      this.auth.logout();
      this.router.navigateByUrl('/login').then(() => {
      })
    }
  }

  login() {
    if (this.loginForm.invalid) {
      return;
    }

    this.loading.set(true);
    const { phone } = this.loginForm.getRawValue();

    this.auth.loginByPhone(phone!).then((r) => {
      if (!r.token) {
        this.loading.set(false);
      }
    }).catch(() => {
      this.loading.set(false);
      alert(this.transloco.translate("Login failed"))
    });
  }
}
